module.exports = __webpack_public_path__ + "img/SB_Full_Colour_ATA_Stanbic_Logo_Horizontal_RGB_1.d2e7ef94.png";